import React, { Component } from 'react';
import { Localize } from '../../modules/localize/Localize';

class MainMenuButton extends Component {
    constructor(props) {
        super(props);
    }

    onClick(e) {
        if (this.props.onClick != null) {
            this.props.onClick(this.props.name);
        }
    }

    render() {
        const txtColor = this.props.selected ? "text-txt-selected" : "text-txt-normal";
        //const txtColor = this.props.selected ? "text-gray-800" : "text-gray-500";
        //"bg-gray-300 shadow-inner "
        const bgColor = this.props.selected ? "" : "";

        let name = this.props.text;

        if (name.startsWith("L:")) {
            name = name.slice(2);
            name = Localize.getMsgByPath(name);
        }


        return (
            <div className={"h-16 flex-auto flex flex-col justify-start items-center rounded-md m-2 " + bgColor}
                onClick={e => this.onClick(e)}>
                <img src={
                    this.props.selected ? this.props.img : this.props.imgGray
                } className="w-6 h-6" />
                <span className={txtColor + " text-sm mt-1"}>{name}</span>
            </div>
        )
    }
}


export default MainMenuButton;